module.exports = __webpack_public_path__ + "files/37bdb7f8db233daef529366b5772bb3f.png";